import React, { useEffect, useRef, useState } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { DataTable } from "primereact/datatable";
import {
  defaultPageRowOptions,
  defaultRowOptions,
  InvoiceOrPaymentDropdown,
  paginatorLinks,
  paySchemaOptions,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../appconfig/Settings";
import { Column } from "primereact/column";
import { InvoiceListColumn } from "../../appconfig/DatatableSetting";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useLocation, useNavigate } from "react-router-dom";
import { deleteData, getAllDetails, getDetails, postAllData, postDataByID, updateData } from "../../service/ProductService";
import {
  DELETE_INVOICE,
  GET_INVOICE_LIST,
  GET_INVOICE_PAYEE_LIST,
  PAYMENT_RECEIVED_DATE,
  SEND_EMAIL_AND_UPDATE_STATUS,
} from "../../config/ApiConstant";
import { dateTemplate, dateTemplateWithoutUtc } from "../../appconfig/TemplateFieldSetting";
import InvoiceTab from "./InvoiceTab";
import moment from "moment";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import { Badge } from "primereact/badge";
import { convertDateFrom } from "../../appconfig/AppHelper";
import { validatePaymentReceived } from "../../config/Validate";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { RadioButton } from "primereact/radiobutton";

const InvoiceDetailList = () => {
  document.title = "Invoice List | Nexawage ";

  const navigate = useNavigate();

  // const { id } = useParams();
  // const clientParamId = id ? atob(id) : null;

  // get client id fron navigation state
  const location: any = useLocation();
  const clientParamId = location?.state?.clientId;

  const toast = useRef<any>(null);

  // top horizontal scrollbar synced with the datatable's own scrollbar
  const tableWrapperRef = useRef<HTMLDivElement>(null);
  const topScrollRef = useRef<HTMLDivElement>(null);
  const [tableScrollWidth, setTableScrollWidth] = useState<number>(0);

  // loading
  const [pageLoad, setPageLoad] = useState<boolean>(false);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  // invoice list and selected row
  const [selectedRowId, setSelectedRowId] = useState<any>(null);
  const [invoiceList, setInvoiceList] = useState<any>([]);

  // selected row
  const [selectedRow, setSelectedRow] = useState<any>(null);

  // total anual amount
  const [totalAmount, setTotalAmount] = useState<any>(null);

  // errors obj
  const [errors, setErrors] = useState<any>({});

  //   filter
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);

  // selected payee
  const [selectedPayee, setSelectedPayee] = useState<Number | null>(null);

  // payee Dropdown
  const [payeeDropdown, setPayeeDropdown] = useState<any>([]);

  // confirmation dialog
  const [emailSendDialog, setEmailSendDialog] = useState<boolean>(false);

  // invoice or payment date range selected
  const [rangeDropdownSelected, setRangeDropdownSelected] = useState<any>(null);

  // Delete dialog
  const [deleteDialog, setDeleteDialog] = useState<boolean>(false);

  // payment status dialog
  const [paymentStatusDialog, setPaymentStatusDialog] = useState<boolean>(false);
  const [paymentStatus, setPaymentStatus] = useState<any>(null);
  const [isHold, setIsHold] = useState<any>(null);
  const [paymentDate, setPaymentDate] = useState<Date | null | string | any>();
  const [invoiceSelectedRange, setInvoiceSelectedRange] = useState<string | null>(null);

  // Date states
  let today = new Date();
  const [paymentReceivedDate, setPaymentReceivedDate] = useState<string | Date | any | null>(null);

  // payment received range end date
  const [paymentReceivedEndDate, setPaymentReceivedEndDate] = useState<string | Date | any | null>(null);

  let todayDate = new Date();
  // invoice dates
  const [invoiceDate, setInvoiceDate] = useState<string | Date | any | null>(new Date(todayDate.setDate(today.getDate() - 31)));

  // invoice end date
  const [invoiceEndDate, setInvoiceEndDate] = useState<string | Date | any | null>(new Date());

  // status filter template
  const [category, setCategory] = useState<any>(null);

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const userRole = userData?.roles?.role_name || "";

  // filter
  const emptyFilters = {
    global: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },

    pay_schema: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    email: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    phone: {
      operator: FilterOperator.OR,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    date: {
      operator: FilterOperator.OR,
      constraints: [
        {
          value: null,
          matchMode: FilterMatchMode.DATE_IS,
        },
      ],
    },
    payment_received_date: {
      operator: FilterOperator.OR,
      constraints: [
        {
          value: null,
          matchMode: FilterMatchMode.DATE_IS,
        },
      ],
    },
    due_date: {
      operator: FilterOperator.OR,
      constraints: [
        {
          value: null,
          matchMode: FilterMatchMode.DATE_IS,
        },
      ],
    },
  };
  const [filters, setFilters] = useState<any>(emptyFilters);

  // client id based on login
  let clientId: any = null;
  if (userRole === "User") {
    clientId = clientParamId;
  } else {
    clientId = userData?.id;
  }

  // useEffect to get invoice list and payee details
  useEffect(() => {
    getInvoiceList();
    getPayeeNameAndDetail();
  }, [selectedPayee, paymentReceivedDate, paymentReceivedEndDate, invoiceDate, invoiceEndDate, rangeDropdownSelected]);

  // keep the top scrollbar in sync with the datatable's own horizontal scrollbar
  useEffect(() => {
    const wrapper = tableWrapperRef.current?.querySelector(".p-datatable-wrapper") as HTMLDivElement | null;
    const topScroll = topScrollRef.current;
    if (!wrapper || !topScroll) return;

    const updateScrollWidth = () => setTableScrollWidth(wrapper.scrollWidth);
    updateScrollWidth();

    const handleTableScroll = () => (topScroll.scrollLeft = wrapper.scrollLeft);
    const handleTopScroll = () => (wrapper.scrollLeft = topScroll.scrollLeft);

    wrapper.addEventListener("scroll", handleTableScroll);
    topScroll.addEventListener("scroll", handleTopScroll);
    window.addEventListener("resize", updateScrollWidth);

    return () => {
      wrapper.removeEventListener("scroll", handleTableScroll);
      topScroll.removeEventListener("scroll", handleTopScroll);
      window.removeEventListener("resize", updateScrollWidth);
    };
  }, [pageLoad, invoiceList]);

  // get invoice list api call
  const getInvoiceList = async () => {
    try {
      setPageLoad(false);

      const response = await getDetails(
        `${GET_INVOICE_LIST}/${clientId}?recipient_id=${selectedPayee}&payment_received_start_date=${!window.cn(paymentReceivedDate) ? convertDateFrom(paymentReceivedDate) : ""
        }&payment_received_end_date=${!window.cn(paymentReceivedEndDate) ? convertDateFrom(paymentReceivedEndDate) : ""}&invoice_start_date=${rangeDropdownSelected === "Invoice Range" && !window.cn(invoiceDate) ? convertDateFrom(invoiceDate) : ""
        }&invoice_end_date=${rangeDropdownSelected === "Invoice Range" && !window.cn(invoiceEndDate) ? convertDateFrom(invoiceEndDate) : ""}&due_date=${rangeDropdownSelected === "Due Date" ? convertDateFrom(new Date()) : ""}`,
      );

      // normalise date — append T00:00:00 (no tz) so new Date parses as local midnight, not UTC
      const normalized = response?.data?.map((item: any) => ({
        ...item,
        date: item.date ? new Date(item.date.substring(0, 10) + "T00:00:00") : null,
        payment_received_date: item?.payment_received_date ? new Date(item.payment_received_date.substring(0, 10) + "T00:00:00") : null,
        due_date: item.due_date ? new Date(item.due_date.substring(0, 10) + "T00:00:00") : null,

        // searchable strings for global filter
        date_search: item.date ? moment(item.date).format("DD MMM YYYY") : "",
        payment_receive_date_search: item?.payment_received_date ? moment(item?.payment_received_date).format("DD MMM YYYY") : "",
      }));

      // set invoice list
      setInvoiceList(normalized);

      setTotalAmount(response?.totalAmount);
      setPageLoad(true);
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // get payee name using api call
  const getPayeeNameAndDetail = async () => {
    try {
      const response = await getAllDetails(`${GET_INVOICE_PAYEE_LIST}/${clientId}`);

      if (response) {
        const DataList = response;
        if (DataList.length === 0) {
          setPayeeDropdown([]);
        } else {
          const DataList = response.map((item: any) => ({
            name: `${item?.bill_to}`,
            value: item?.id,
          }));
          setPayeeDropdown(DataList);
        }
      }
    } catch (error) { }
  };

  // update email status api call
  const sendEmail = async () => {
    try {
      setSubmitLoading(true);
      const response = await postDataByID(SEND_EMAIL_AND_UPDATE_STATUS, selectedRowId);
      if (response) {
        getInvoiceList();
        hideEmailDialog();
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Alert",
        detail: error?.response?.data?.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // api call for payment received date
  const paymentReceived = async () => {
    try {
      const { errors, isError } = validatePaymentReceived(paymentDate);
      setErrors(errors);
      if (isError) return;
      setSubmitLoading(true);

      const payload = {
        payment_received_date: paymentDate,
      };

      const response = await updateData(PAYMENT_RECEIVED_DATE, selectedRowId, payload);
      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response?.message,
        });
        hidePaymentStatusDialog();
        getInvoiceList();
      }
    } catch (error: any) {
      toast.current.show({
        severity: "error",
        summary: "Alert",
        detail: error?.response?.data?.error,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // on payment date change
  const onDateChange = (e: any) => {
    let val;
    let dateVal;
    val = e?.terget?.value ?? e?.value;
    dateVal = moment(val).format("YYYY-MM-DD");
    setPaymentDate(dateVal);
    setErrors({});
  };

  // input payment received date handler
  const onPaymentReceivedDateChange = (e: any) => {
    setPaymentReceivedDate(e.value);
    setInvoiceDate(null);
  };

  const onPaymentReceivedEndDateChange = (e: any) => {
    setPaymentReceivedEndDate(e.value);
    setInvoiceEndDate(null);
  };

  // invoice date change dropdown
  const onInvoiceDateChange = (e: any) => {
    setInvoiceDate(e.value);
    setPaymentReceivedDate(null);
    applyDateFilter(e.value, invoiceEndDate);
  };

  const onInvoiceEndDateChange = (e: any) => {
    setInvoiceEndDate(e.value);
    setPaymentReceivedEndDate(null);
    applyDateFilter(invoiceDate, e.value);
  };

  const applyDateFilter = (start: any, end: any) => {
    let _filters = { ...filters };
    _filters["date"] = {
      operator: FilterOperator.AND,
      constraints: [
        { value: start, matchMode: FilterMatchMode.DATE_AFTER },
        { value: end, matchMode: FilterMatchMode.DATE_BEFORE },
      ],
    };
    setFilters(_filters);
  };

  // clear all fields
  const ClearAll = () => {
    setFilters({ ...emptyFilters });
    setGlobalFilter(null);
    setGlobalFieldFilter(null);
    setSelectedPayee(null);
    setPaymentReceivedDate(null);
    setInvoiceDate(new Date(new Date().setDate(new Date().getDate() - 31)));
    setInvoiceEndDate(new Date());
    setPaymentReceivedEndDate(null);
    setRangeDropdownSelected(null);
  };

  // open dialogdialog
  const confirmantionEmailDialog = async (rowData: any) => {
    setEmailSendDialog(true);
    setSelectedRowId(rowData?.id);
    setSelectedRow(rowData);
  };

  // open payment status dialog
  const onPaymentStatusChange = (rowData: any, e: any) => {
    setPaymentStatusDialog(true);
    setSelectedRowId(rowData?.id);
    setPaymentStatus(e?.target?.value);
  };

  // hide email modal
  const hideEmailDialog = () => {
    setEmailSendDialog(false);
    setSubmitLoading(false);
    setSelectedRow(null);
  };

  // hide payment status dialog
  const hidePaymentStatusDialog = () => {
    setPaymentStatusDialog(false);
    setSelectedRowId(null);
    setPaymentDate(null);
    setErrors({});
  };

  // global search filter on change
  const onGlobalFilterChange = (e: any) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilter(value);
  };

  //   left toolbar template
  const leftToolbarTemplate = () => (
    <>
      <span className="block mr-2 p-input-icon-left">
        <i className="pi pi-search" />
        {/* <InputText type="search" value={globalFilter || ""} onChange={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." /> */}
        <InputText type="search" value={globalFilter || ""} onChange={onGlobalFilterChange} placeholder="Search..." />
      </span>

      <Dropdown
        id="payee"
        value={selectedPayee}
        onChange={(e) => setSelectedPayee(e.value)}
        options={payeeDropdown}
        optionLabel="name"
        placeholder="Select Payee"
        name="selectedPayee"
        className=" w-16rem ml-3"
      ></Dropdown>
    </>
  );

  //   right toolbar template
  const rightToolbarTemplate = () => (
    <>
      <div className="p-toolbar-group-right-invoice">
        {/* dropdown to select date range */}
        <Dropdown
          id="dateRange"
          value={rangeDropdownSelected}
          onChange={(e) => {
            setRangeDropdownSelected(e.value);
            if (e.value === "Due Date") {
              // We do not do extra filtering from frontend side for Due Date
              // as requested, we only pass it in api param.
              let _filters = { ...filters };
              _filters["due_date"].constraints[0].value = null;
              _filters["date"].constraints[0].value = null;
              _filters["payment_received_date"].constraints[0].value = null;

              setFilters(_filters);
              setInvoiceDate(null);
              setInvoiceEndDate(null);
              setPaymentReceivedDate(null);
              setPaymentReceivedEndDate(null);
            } else {
              // Clear due date filter if other range selected
              let _filters = { ...filters };
              _filters["due_date"].constraints[0].value = null;
              setFilters(_filters);
            }
          }}
          options={InvoiceOrPaymentDropdown}
          optionLabel="name"
          placeholder="Select Invoice or Payment Range"
          name="rangeDropdownSelected"
          className=" w-16rem ml-3"
        ></Dropdown>

        {/* calendar based on invoice or payment range */}
        {rangeDropdownSelected === "Invoice Range" ? (
          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <label className="label-text mb-2">Select Invoice Range From</label>
              <div>
                <Calendar
                  value={invoiceDate}
                  onChange={(e) => onInvoiceDateChange(e)}
                  readOnlyInput
                  dateFormat="dd/mm/yy"
                  placeholder="Select Date From"
                  showIcon
                  className="w-16rem ml-2 p-0.5rem"
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <label className="label-text mb-2">Select Invoice Range To</label>
              <div>
                <Calendar
                  value={invoiceEndDate}
                  onChange={(e) => onInvoiceEndDateChange(e)}
                  readOnlyInput
                  dateFormat="dd/mm/yy"
                  placeholder="Select Date To"
                  showIcon
                  className="w-16rem ml-2 p-0.5rem"
                />
              </div>
            </div>
          </div>
        ) : rangeDropdownSelected === "Payment Received Range" ? (
          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <label className="label-text mb-2">Select Payment Received Range From</label>
              <div>
                <Calendar
                  value={paymentReceivedDate}
                  onChange={(e) => onPaymentReceivedDateChange(e)}
                  readOnlyInput
                  dateFormat="dd/mm/yy"
                  placeholder="Select Date From"
                  showIcon
                  className="w-16rem ml-2"
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <label className="label-text mb-2">Select Payment Received Range To</label>
              <div>
                <Calendar
                  value={paymentReceivedEndDate}
                  onChange={(e) => onPaymentReceivedEndDateChange(e)}
                  readOnlyInput
                  dateFormat="dd/mm/yy"
                  placeholder="Select Date To"
                  showIcon
                  className="w-16rem ml-2"
                />
              </div>
            </div>
          </div>
        ) : null}

        <div style={{ display: "flex", alignItems: "end" }}>
          <Button icon="pi pi-filter-slash" label="Clear" onClick={ClearAll} className="mr-3 ml-3 p-button-outlined common-p-outline-button" />
        </div>

        {/* <Button
        label="Create New Invoice"
        icon="pi pi-plus"
        className="p-button-primary"
        onClick={() => navigate("/invoice")}
      /> */}
      </div>
    </>
  );

  // view pdf
  const viewPdf = (rowData: any) => {
    if (rowData.invoice_url) {
      window.open(rowData.invoice_url, "_blank");
    } else {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "PDF NOT FOUND",
      });
    }
  };

  // action body template
  const invoicePdfTemplate = (rowData: any) => (
    <>
      <div className="actions">
        <Button
          icon="pi pi-file-pdf"
          tooltip="View Invoice"
          className="p-button-secondary common-view-pdf-btn"
          tooltipOptions={{ position: "bottom" }}
          onClick={() => viewPdf(rowData)}
        />
      </div>
    </>
  );

  // delete confirmation modal
  const confirmDelete = (deleteID: any) => {
    setSelectedRowId(deleteID);
    setDeleteDialog(true);
  };

  // delete employee api call
  const deleteInvoice = async () => {
    try {
      setSubmitLoading(true);
      const response = await deleteData(DELETE_INVOICE, selectedRowId);
      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Deleted",
          detail: response.message,
        });
        hideDeleteDialog();
        getInvoiceList();
        setSubmitLoading(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setSubmitLoading(false);
    }
  };

  // hide delete modal
  const hideDeleteDialog = () => {
    setDeleteDialog(false);
    setSelectedRowId(null);
  };

  // Wage body template
  const wageTEmplate = (rowData: any) => {
    const wage = rowData.total ? `$${rowData?.total}` : "-";
    return <div className="actions">{wage}</div>;
  };

  // send email template
  const actionBodyTemplate = (rowData: any) => {
    return (
      <div className="name">
        <Button
          tooltip={rowData?.send_mail === true ? "email send already" : "Send Email"}
          tooltipOptions={{ position: "bottom" }}
          className={`mr-2 ${rowData?.send_mail === true ? "p-button-success" : "common-primary-button"}`}
          icon="pi pi-envelope"
          label=""
          onClick={() => confirmantionEmailDialog(rowData)}
        />

        <Button
          icon="pi pi-pencil"
          tooltip="Edit Invoice"
          className="common-edit-btn "
          tooltipOptions={{ position: "bottom" }}
          disabled={rowData?.payment_status === "Completed"}
          onClick={() =>
            navigate(`/edit-invoice/${btoa(rowData?.id)}`, {
              state: { id: rowData?.id, payee_id: rowData?.invoice_recipient_id, clientId: clientId },
            })
          }
        />

        <Button
          icon="pi pi-trash"
          tooltipOptions={{ position: "bottom" }}
          className="ml-2 p-button-danger common-delete-btn"
          tooltip="Delete"
          onClick={() => confirmDelete(rowData.id)}
        />
      </div>
    );
  };

  // payment status template
  const paymentStatusTemplate = (rowData: any) => {
    let statusClass: any = rowData.payment_status === "Pending" ? "danger" : "success";
    return (
      <div className="actions flex flex-column align-items-center">
        <InputSwitch
          className="mr-2 mb-2"
          value={paymentStatus}
          disabled={rowData?.payment_status === "Completed"}
          checked={rowData?.payment_status === "Pending" ? false : true}
          onChange={(e) => onPaymentStatusChange(rowData, e)}
        />
        <Badge
          severity={statusClass}
          value={rowData.payment_status === "Completed" ? "Received" : "Pending"}
          style={{ width: "fit-content" }}
        ></Badge>
      </div>
    );
  };

  // date filter template
  const dateFilterTemplate = (options: any) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => options.filterApplyCallback(e.value)}
        dateFormat="dd/mm/yy"
        placeholder="Select Date"
        showIcon
      />
    );
  };

  //status Filter Template
  const categorySchemaTemplate = (options: any) => {
    return (
      <Dropdown
        // filter
        value={category}
        onChange={(e: any) => {
          setCategory(e.value);
          options.filterCallback(e.value ? e.value : null, options.index);
        }}
        options={paySchemaOptions}
        optionLabel="name"
        placeholder="Category"
        className="order-drp"
      ></Dropdown>
    );
  };

  return (
    <>
      <AppBreadcrumb currentMenu="Invoice" pageName="List" pageTitle="Invoice List" goToPage={userRole === "User"} />

      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white crud-demo lg:p-2">
            <InvoiceTab index={1} id={clientId} />
            <Toast ref={toast} />
            {invoiceList.length > 0 && (
              <div className="flex align-item-center justify-content-center">
                <h4 className="">Total Amount Of Current Year : ${totalAmount?.toFixed(2)}</h4>
              </div>
            )}

            <Toolbar className="gap-3 invoice-right-tab" left={leftToolbarTemplate} right={rightToolbarTemplate} />

            {pageLoad && (
              <div ref={topScrollRef} style={{ overflowX: "auto", overflowY: "hidden" }}>
                <div style={{ width: tableScrollWidth, height: "1px" }} />
              </div>
            )}

            <div ref={tableWrapperRef}>
            {pageLoad ? (
              <DataTable
                value={invoiceList}
                showGridlines
                dataKey="id"
                stripedRows
                globalFilter={globalFilter}
                rows={defaultRowOptions}
                paginator={invoiceList?.length > 0}
                rowsPerPageOptions={defaultPageRowOptions}
                className="datatable-responsive p-datatble-sm"
                paginatorTemplate={paginatorLinks}
                currentPageReportTemplate={showingEntries + " Invoice Detail"}
                emptyMessage="No Invoice Data Found"
                // filters={globalFieldFilter}
                // onFilter={(e) => setGlobalFieldFilter(e.filters)}
                filters={filters}
                onFilter={(e: any) => setFilters(e.filters)}
                globalFilterFields={[
                  "invoice_no",
                  "payment_status",
                  "bill_to",
                  "bill_email",
                  "bill_phone",
                  "bill_address",
                  "total",
                  "date_search",
                  "payment_receive_date_search",
                ]}
                removableSort
                responsiveLayout={"scroll"}
              >
                {InvoiceListColumn.map((col, i) => {
                  if (col.field === "invoice_url") {
                    return <Column key={col.field} field={col.field} header={col.header} body={invoicePdfTemplate} />;
                  } else if (col.field === "date") {
                    return (
                      <Column
                        field="date"
                        header="Date"
                        sortable
                        body={dateTemplateWithoutUtc}
                        dataType="date"
                      />
                    );
                  } else if (col.field === "payment_received_date") {
                    return (
                      <Column
                        field={col.field}
                        header={col.header}
                        sortable
                        body={dateTemplateWithoutUtc}
                        dataType="date"
                        filter
                        filterElement={dateFilterTemplate}
                      />
                    );
                  } else if (col.field === "due_date") {
                    return (
                      <Column
                        field={col.field}
                        header={col.header}
                        sortable
                        body={dateTemplateWithoutUtc}
                        dataType="date"
                      />
                    );
                  } else if (col.field === "invoice_no") {
                    return <Column key={col.field} field={col.field} header={col.header} sortable />;
                  } else if (col.field === "action") {
                    return <Column key={col.field} field={col.field} header={col.header} body={actionBodyTemplate} />;
                  } else if (col.field === "total") {
                    return <Column key={col.field} field={col.field} header={col.header} body={wageTEmplate} />;
                  } else if (col.field === "payment_status") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={paymentStatusTemplate}
                        dataType="date"
                        filter
                        filterElement={dateFilterTemplate}
                      />
                    );
                  } else {
                    return <Column key={col.field} field={col.field} header={col.header} />;
                  }
                })}
              </DataTable>
            ) : (
              <DataTable value={Skeletonitems}>
                {InvoiceListColumn.map((col, i) => (
                  <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                ))}
              </DataTable>
            )}
            </div>
          </Card>
        </div>
      </div>

      {/* Email Send Dialog */}
      <Dialog
        visible={emailSendDialog}
        style={{ width: "550px" }}
        draggable={false}
        className="mx-3 lg:mx-0"
        header={"Confirmation To send Email"}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" disabled={submitLoading} onClick={hideEmailDialog} />
            <Button label="Send Email" icon="pi pi-check" className="common-primary-button" onClick={sendEmail} loading={submitLoading} />
          </div>
        }
        onHide={hideEmailDialog}
      >
        {/* <h4>Are you sure you want to send email ? </h4> */}
        <p className="text-lg">
          {` Are you sure you want to send email to `} <span className="font-bold">{`${selectedRow?.bill_email}`}</span>
        </p>
        <div className="grid p-fluid formgrid"></div>
      </Dialog>

      {/* payment status dialog */}
      <Dialog
        visible={paymentStatusDialog}
        style={{ width: "450px" }}
        draggable={false}
        className="mx-3 lg:mx-0"
        header={"Payment Date"}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="mr-2 p-button-secondary"
              disabled={submitLoading}
              onClick={hidePaymentStatusDialog}
            />
            <Button label="Submit" icon="pi pi-check" className="common-primary-button" onClick={paymentReceived} loading={submitLoading} />
          </div>
        }
        onHide={hidePaymentStatusDialog}
      >
        <div className="grid p-fluid formgrid">
          {/* Date of Payment */}
          <div className="field col-12 md:col-8">
            <label htmlFor="date">Enter Date of Payment Received *</label>
            <div className="input-effect-div">
              <Calendar
                value={paymentDate ? moment(paymentDate, "YYYY-MM-DD").toDate() : null}
                dateFormat="dd/mm/yy"
                placeholder="Enter Date Of Payment"
                onChange={(e) => onDateChange(e)}
                showIcon
                className={errors["paymentDate"] && "p-invalid"}
              />
            </div>
            <small className="p-invalid-txt">{errors["paymentDate"]}</small>
          </div>
        </div>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog
        visible={deleteDialog}
        header="Delete Invoice"
        draggable={false}
        className="mx-3 lg:mx-0"
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideDeleteDialog} />
            <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteInvoice} loading={submitLoading} />
          </div>
        }
        onHide={hideDeleteDialog}
      >
        <div className="flex align-items-center justify-content-start">
          <i className="mr-3 pi pi-exclamation-triangle delete-triangle" style={{ fontSize: "2rem" }} />
          <span className="delete-dialog-note">Are you sure you want to delete this Invoice ?</span>
        </div>
      </Dialog>
    </>
  );
};

export default InvoiceDetailList;
